import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { api } from '@/services/api'
import { Addon, AddonCreateRequest, AddonUpdateRequest } from '@/types'
import { toast } from 'sonner'

const ADDONS_QUERY_KEY = 'addons'

export const useAddons = () => {
  return useQuery<Addon[]>({
    queryKey: [ADDONS_QUERY_KEY],
    queryFn: async () => {
      const { data } = await api.get('/credit-costs/addons')
      return data
    },
  })
}

export const useCreateAddon = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (addon: AddonCreateRequest) => {
      const { data } = await api.post('/credit-costs/addons', addon)
      return data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [ADDONS_QUERY_KEY] })
      toast.success('Add-on creado')
    },
  })
}

export const useUpdateAddon = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({ id, updates }: { id: string; updates: AddonUpdateRequest }) => {
      const { data } = await api.patch(`/credit-costs/addons/${id}`, updates)
      return data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [ADDONS_QUERY_KEY] })
      toast.success('Add-on actualizado')
    },
  })
}

export const useToggleAddon = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (id: string) => {
      const { data } = await api.post(`/credit-costs/addons/${id}/toggle`)
      return data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [ADDONS_QUERY_KEY] })
      toast.success('Estado del add-on actualizado')
    },
  })
}
